import * as React from 'react';
import { PriceType } from "../../../classes/price-type";
import { IOption } from '../../../classes/seating-option';
import { IExchangeTicket } from '../../../classes/ticket-exchange';
import PromoCodeContainer from '../../../common/promo-code/promo-code';
import { IPriceRangeModel, IAdditionalSeatingOptionModel } from '../../../filter/reducers/filter-reducers';
import { formatString } from '../../../helpers/string-format';
import { IAppSettingsModel } from '../../../reducers/fetch-settings-reducer';
import Cart from './cart';
import Subtotal from './subtotal';
import AdditionalNotes from '../../../common/notes/additional-notes';
import { ItemType } from '../../../classes/item-type';
import { IPromoCodeModel } from '../../../filter/reducers/promo-reducer';
import { ISeatMapModel } from '../../reducers/seatmap-reducer';
import { ICartModel } from '../../../cart/reducers/cart-reducer';
import { convertStringListToString } from '../../../helpers/array-helpers';
import { toggleSeatmapCart } from '../../../seatmap/actions/seatmap-actions';
import { AisleIndicator, Seat, SeatInfo } from '../../../classes/seat';
import isEqual from 'react-fast-compare';
import Modal from '../../../common/modal/modal';

interface IFiltersOverlayProps {
    appSettings: IAppSettingsModel;
    promoCodeModel: IPromoCodeModel;
    //seatMapModel: ISeatMapModel;
    seatmapId: string;
    levelSeats: Array<Seat>;
    selectedSeats: Array<Seat>;
    additionalSeatingOptionModel: IAdditionalSeatingOptionModel;
    cartModel: ICartModel;
    dispatch: any;

    itemType: ItemType;
    isMobile: boolean;
    hidingUpsell: boolean;
    showOverlay: boolean;
    showPromoCode: boolean;

    cartOverlayMessage: string;
    promoCodeTitle: string;
    additionalNotesTitle: string;

    seatmapCartText: string;

    selectedPriceTypes: Array<PriceType>;
    fetchSeatViewImage: boolean;
    viewFromSeatModalActive: boolean;
}

interface ICartOverlayState {
    openPromoCode: boolean;
    openAdditionalNotes: boolean;
}

class CartOverlay extends React.Component<IFiltersOverlayProps, ICartOverlayState> {
    constructor(props) {
        super(props);

        this.state = {
            openPromoCode: false,
            openAdditionalNotes: false
        }
    }

    shouldComponentUpdate(nextProps: IFiltersOverlayProps, nextState: ICartOverlayState) {
        return (nextProps.showOverlay && !isEqual(nextProps, this.props)) || !isEqual(this.state, nextState);
    }

    _togglePromoCodeShow() {
        this.setState({
            openPromoCode: !this.state.openPromoCode
        })
    }

    _toggleAdditionalNotesShow() {
        this.setState({
            openAdditionalNotes: !this.state.openAdditionalNotes
        })
    }

    _toggleSeatmapCart(evt) {
        evt.preventDefault();

        this.props.dispatch(toggleSeatmapCart());
    }

    handleClickOutside = evt => {
        if (this.props.showOverlay) {
            this.props.dispatch(toggleSeatmapCart());
        }
    };

    render() {
        const useTag = `<use xlink:href="#icon-arrow-down" />`;
        const xSvg = `<svg class="close-filters-icon"><use xlink:href="#icon-close" /></svg>`;
        const lastSectionClass = " overlay-filter-section-last";
        const showPromoCode = this.props.itemType !== ItemType.Flex && this.props.itemType !== ItemType.Super && this.props.appSettings.enablePromoCodes;

        const minQuantityPriceTypeErrorMessage = this.props.cartModel.flexMinQuantityReachedForPriceType == null ? ""
            : this.props.appSettings.minimumSeatsSingleTicketRequiredMessage.replace("{0}", this.props.cartModel.flexMinQuantityReachedForPriceType.title);

        var orphanedSeat = "";
        if (!this.props.appSettings.allowOrphanedSeats) {
            orphanedSeat = this.checkForOrphanedSeats();
        }

        var requiresConsecutiveSeat: SeatInfo = null;

        if (this.props.appSettings.forcePatronsReserveWholeRow) {
            requiresConsecutiveSeat = this.checkForMissingSameConsecutivesSeats();
        }
        else if (this.props.appSettings.forcePatronsReserveInMultiples > 0 || this.props.appSettings.minimumTicketsPerSeatGroup > 0) {
            requiresConsecutiveSeat = this.checkForMissingConsecutiveSeats();
        }


        return (
            <div className="overlay-section overlay-section-cart">
                <div className="overlay-section-header">
                    <button type="button" className="sidebar-section-toggle" onClick={(evt) => this._toggleSeatmapCart(evt)} aria-expanded={this.props.showOverlay}>
                        <h2 className="heading-general" tabIndex={-1}>{this.props.seatmapCartText}</h2>
                        <div dangerouslySetInnerHTML={{ __html: xSvg }} ></div>
                    </button>

                </div>

                <div className="overlay-section-combined">
                    <Cart
                        selectedAdditionalOptionGroups={this.props.additionalSeatingOptionModel.additionalSeatingOptions.filter(optionGroup => optionGroup.groupSelected)}
                        cartSeats={this.props.cartModel.seats}
                        dispatch={this.props.dispatch}
                        itemId={this.props.appSettings.itemId}
                        selectedPriceTypes={this.props.selectedPriceTypes}
                        {...this.props.appSettings}
                        seatMapId={this.props.seatmapId}
                        selectedSeatIds={convertStringListToString(this.props.selectedSeats.map(s => s.seatId))}
                        allSeats={this.props.levelSeats}
                        cartDisabled={this.props.cartModel.cartDisabled}
                        additionalNotes={this.props.additionalSeatingOptionModel.additionalNotes}
                        fetchSeatViewImage={this.props.fetchSeatViewImage}
                        appSettings={this.props.appSettings}
                    />

                    {showPromoCode ?
                        <div className={"overlay-filter-section" + (!this.props.appSettings.renderAdditionalNotes ? lastSectionClass : '')}>
                            <PromoCodeContainer collapseDown={false} culture={this.props.appSettings.currentCulture} />
                        </div>
                        : null}

                    {this.props.appSettings.renderAdditionalNotes ?
                        <div className={"overlay-filter-section" + lastSectionClass}>
                            <p className="caption-paragraph">
                                <button aria-expanded={this.state.openAdditionalNotes} className="filter-title" onClick={this._toggleAdditionalNotesShow.bind(this)}>
                                    {this.props.additionalNotesTitle}
                                    <svg className={"filters-section-heading-toggles-icon" + (!this.state.openAdditionalNotes ? " toggled" : "")} aria-hidden="true" dangerouslySetInnerHTML={{ __html: useTag }} />
                                </button>
                            </p>
                            {this.state.openAdditionalNotes ?
                                <AdditionalNotes />
                                : null
                            }
                        </div>

                        : null
                    }

                </div>
                <div className="overlay-section-subtotal">
                    <Subtotal
                        selectedAdditionalOptionGroups={this.props.additionalSeatingOptionModel.additionalSeatingOptions.filter(optionGroup => optionGroup.groupSelected)}
                        cartSeats={this.props.cartModel.seats}
                        dispatch={this.props.dispatch}
                        itemId={this.props.appSettings.itemId}
                        {...this.props.appSettings}
                        cartDisabled={this.props.cartModel.cartDisabled || (orphanedSeat.length > 0) || (requiresConsecutiveSeat != null)}
                        cartErrorMessage={
                            requiresConsecutiveSeat != null ?
                                this.props.appSettings.forceMultipleCartMessageText
                                    .replace("{RowText}", requiresConsecutiveSeat.rowText)
                                    .replace("{NumberText}", requiresConsecutiveSeat.numberText)
                                :
                                (orphanedSeat.length > 0) ?
                                    this.props.appSettings.leaveOrphanedSeatsMessage
                                        .replace("{RowText}", orphanedSeat.split('~')[0])
                                        .replace("{NumberText}", orphanedSeat.split('~')[1])
                                    : ""}
                        minQuantityNotReached={this.props.cartModel.flexMinQuantityReachedForPriceType != null}
                        minQuantityNotReachedMessage={minQuantityPriceTypeErrorMessage}
                        additionalNotes={this.props.additionalSeatingOptionModel.additionalNotes}
                    />
                </div>


            </div>
        )
    }

    // returns the first seat that will is orphaned
    private checkForOrphanedSeats(): string {
        const cartSeatNumbers = this.props.cartModel.seats.map(s => s.tessituraSeat.seatNumber);

        var orphanedSeats = "";
        var seatsCausingOrphan = this.props.cartModel.seats.filter(seat => {
            var consecutiveSeats = this.props.levelSeats.filter(levelSeat => cartSeatNumbers.indexOf(levelSeat.tessituraSeat.seatNumber) < 0
                && levelSeat.tessituraSeat.consecutiveSeatGroupId == seat.tessituraSeat.consecutiveSeatGroupId);
            if (consecutiveSeats.length == 0)
                return false;
            if (consecutiveSeats.length == 1) {
                //if the seat is not an aisle
                if (consecutiveSeats[0].tessituraSeat.aisle == AisleIndicator.None) {
                    orphanedSeats = consecutiveSeats[0].tessituraSeat.rowText + "~" + consecutiveSeats[0].tessituraSeat.numberText;
                    return true;
                }
                else
                    return false;
            }
            var canStillReserveSeats = consecutiveSeats.filter(cSeat => {
                //if it is an aisle then we'll let it slide
                if (cSeat.tessituraSeat.aisle !== AisleIndicator.None) {
                    return true;
                }
                var seatToRight = consecutiveSeats.filter(c => c.tessituraSeat.logicalSeatNumber == cSeat.tessituraSeat.logicalSeatNumber + 1);
                var seatToLeft = consecutiveSeats.filter(c => c.tessituraSeat.logicalSeatNumber == cSeat.tessituraSeat.logicalSeatNumber - 1);
                if (seatToRight.length < 1 && seatToLeft.length < 1) {
                    orphanedSeats = cSeat.tessituraSeat.rowText + "~" + cSeat.tessituraSeat.numberText;
                    return false;
                }

                return true;
            });

            return canStillReserveSeats.length !== consecutiveSeats.length;
        });

        if (seatsCausingOrphan.length > 0) {
            return orphanedSeats;
        }

        return "";
    }

    // this check will look to see if we are forcing a certain number of consecutive seats. 
    // If we are and the patron has fulfilled the multiple, this will return the seat that is missing consecutive seats
    private checkForMissingConsecutiveSeats(): SeatInfo {
        const cartSeatNumbers = this.props.cartModel.seats.map(s => s.tessituraSeat.seatNumber);

        var orphanedSeats = null;
        var seatsCausingNotEnoughForcedConsecutive = this.props.cartModel.seats.filter(seat => {

            if (cartSeatNumbers.length === 1) {
                orphanedSeats = seat.tessituraSeat;
                return true;
            }

            var consecutiveSeatsInCart = this.props.levelSeats.filter(levelSeat => levelSeat.tessituraSeat.consecutiveSeatGroupId == seat.tessituraSeat.consecutiveSeatGroupId
                && levelSeat.tessituraSeat.seatNumber !== seat.tessituraSeat.seatNumber
                && cartSeatNumbers.indexOf(levelSeat.tessituraSeat.seatNumber) >= 0
            );

            if (consecutiveSeatsInCart.length + 1 < this.props.appSettings.minimumTicketsPerSeatGroup) {
                orphanedSeats = seat.tessituraSeat;
                return true;
            }                

            if (this.props.appSettings.forcePatronsReserveInMultiples > 0) {
                if ((consecutiveSeatsInCart.length + 1) % this.props.appSettings.forcePatronsReserveInMultiples == 0) {
                    return false;
                } else {
                    orphanedSeats = seat.tessituraSeat;

                    return true;
                }
            }
            else
            {
                return false;
            }
        });

        if (seatsCausingNotEnoughForcedConsecutive.length > 0) {
            return orphanedSeats;
        }

        return null;
    }

    // this check will look to see if we are forcing patrons to reserve all available seats in a consecutive group. 
    // If we are and the patron has not fulfilled the whole row, this will return the seat that is missing consecutive seats
    private checkForMissingSameConsecutivesSeats(): SeatInfo {
        const cartSeatNumbers = this.props.cartModel.seats.map(s => s.tessituraSeat.seatNumber);

        var missingSeats = null;
        var seatsCausingNotEnoughForcedConsecutive = this.props.cartModel.seats.filter(seat => {

            var seatsInRow = this.props.levelSeats.filter(lvlS => lvlS.tessituraSeat.isAvailable && lvlS.tessituraSeat.consecutiveSeatGroupId === seat.tessituraSeat.consecutiveSeatGroupId);

            var reservedAllSeats = seatsInRow.every(rowSeat => cartSeatNumbers.indexOf(rowSeat.tessituraSeat.seatNumber) >= 0);

            if (reservedAllSeats) {
                return false;
            }

            missingSeats = seat.tessituraSeat;
            return true;
        });

        if (seatsCausingNotEnoughForcedConsecutive.length > 0) {
            return missingSeats;
        }

        return null;
    }
}

export default CartOverlay;